export default __webpack_public_path__ + "static/BannerGenericIconTextAndTitle-af9f34d40f42844b2e6fe2413f9579ce.jpg";